import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "editor-text-italic-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5, fill: "none", fillRule: "evenodd", strokeLinecap: "round" },
        React.createElement("path", { strokeLinejoin: "round", d: "M13.5 6l-3 12" }),
        React.createElement("path", { d: "M11 5.75h5m-8 12.5h5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
